import { WHATSAPP_CHANNEL } from 'src/constants/conversations';
import { WSP_PLUGIN } from 'src/constants/plugins';
import { isPluginAvailable } from 'src/utils/store/isPluginAvailable';
import { CHANNEL_BLOCK_REASON, SESSION_WINDOW } from '../constants';
import { getWhatsappSessionWindow } from '../isWhatsappSessionOpen';
import { resolveAreaSender } from '../resolveAreaSender';
import { IChannelStrategy, TChannelBlockReason } from '../types';

/**
 * WhatsApp (Twilio or Meta): templates need an active sender; free-form messages
 * also need an existing conversation with an open (or unknown) 24 h session.
 */
export const whatsappStrategy: IChannelStrategy = {
    resolve: ({ conversation, store, area, now }) => {
        const sender = resolveAreaSender(
            area,
            WHATSAPP_CHANNEL,
            conversation?.provider
        );
        const senderBlockReason: TChannelBlockReason | null =
            !store || !isPluginAvailable(store, WSP_PLUGIN) || !sender.active
                ? CHANNEL_BLOCK_REASON.CHANNEL_INACTIVE
                : !sender.senderPhone
                  ? CHANNEL_BLOCK_REASON.NO_SENDER
                  : null;
        const sessionWindow = conversation
            ? getWhatsappSessionWindow(conversation, now)
            : SESSION_WINDOW.UNKNOWN;
        const freeFormBlockReason =
            senderBlockReason ||
            (!conversation
                ? CHANNEL_BLOCK_REASON.NO_CONVERSATION
                : sessionWindow === SESSION_WINDOW.EXPIRED
                  ? CHANNEL_BLOCK_REASON.SESSION_EXPIRED
                  : null);

        return {
            channel: WHATSAPP_CHANNEL,
            provider: sender.provider,
            senderPhone: sender.senderPhone,
            sessionWindow,
            canSendFreeForm: !freeFormBlockReason,
            canSendTemplate: !senderBlockReason,
            freeFormBlockReason,
            templateBlockReason: senderBlockReason,
        };
    },
};
